import {Component, input, viewChild} from '@angular/core';
import {ColumnFilter, TableModule} from 'primeng/table';
import {InputText} from 'primeng/inputtext';

@Component({
  selector: 'app-table-column-filter',
  imports: [TableModule, InputText],
  templateUrl: './table-column-filter.component.html',
})
export class TableColumnFilterComponent {
  readonly field = input.required<string>();

  private readonly columnFilter = viewChild<ColumnFilter>('columnFilter');

  closeMenu(): void {
    this.columnFilter()?.hide();
  }
}
